const ImageLoader = () => {
  return <div className="skeleton h-[500px] rounded-lg h-16 mt-6"></div>;
};

export default ImageLoader;
